import { Button, ColorPicker, Input, Select, Slider, Tabs } from "antd";
import { memo } from "react";
import styled from "styled-components";
import { AiOutlineExpand } from "react-icons/ai";
import StyleTab from "./components/StyleTab";
import { selectedMapDataAtom, showDataTableAtom, showStylePopupAtom } from "../../stores/mapStore";
import { useAtom } from 'jotai';
import { useTranslation } from "react-i18next";
import { FaXmark } from "react-icons/fa6";
import { MapData_Base } from "~/common/typescript/models/MapData";
import { dataTable_selecetedMapData_Atom } from "../DataTablePanel/store";
import { IoEllipsisHorizontal } from "react-icons/io5";
import { PiTable } from "react-icons/pi";
import { LayerItemUtil } from "../LegendPanel/LegendTab/LayerItem/LayerItemUtil";

import { Rnd } from 'react-rnd';

const StylingMapDataPanel = () => {
  const { t } = useTranslation();
  const [selectedMapData, setSelectedMapData] = useAtom(selectedMapDataAtom);
  const [showStylePopup, setShowStylePopup] = useAtom(showStylePopupAtom);
  const [showDataTable, setShowDataTable] = useAtom(showDataTableAtom);
  const [selected_MapData_DataTable, setSelected_MapData_DataTable] = useAtom<MapData_Base>(dataTable_selecetedMapData_Atom);

  const onClick_ZoomToLayer = async () => {
    await LayerItemUtil.zoomToLayer(selectedMapData as MapData_Base);
  }

  if (!selectedMapData) {
    return <></>;
  }

  return (
    <Rnd
      default={{
        x: Math.max(10, window.innerWidth - 330),
        y: 32,
        width: 310,
        height: Math.min(520, window.innerHeight - 80),
      }}
      minWidth={280}
      minHeight={250}
      dragHandleClassName="draggable-header"
      cancel=".no-drag, .no-drag *, button, input, textarea, select, a"
      bounds="window"
      enableResizing={{
        bottom: true,
        bottomRight: true,
        right: true,
        top: false,
        topLeft: false,
        topRight: false,
        left: false,
        bottomLeft: false,
      }}
      style={{ zIndex: 1000 }}
    >
      <UI_Wrapper>
        <UI_Header className="draggable-header" style={{ cursor: 'move', userSelect: 'none' }}>
          <UI_LayerNameInput
            placeholder={t('layer')}
            className="no-drag"
            value={selectedMapData.title || selectedMapData.name}
            style={{ marginRight: 8 }}
          />
          <FaXmark
            className="no-drag"
            style={{ cursor: 'pointer', flexShrink: 0 }}
            onClick={() => { setShowStylePopup(false) }}
          />
        </UI_Header>


    <UI_Body_Wrapper>
      <UI_Controllers>
        {/* Phóng tới lớp */}
        <Button type='text' style={{ padding: 8 }} onClick={onClick_ZoomToLayer}>
          <AiOutlineExpand />
        </Button>
        {/* End Phóng tới lớp */}

        {/* Toggle Data Table */}
        <Button type='text' style={{ padding: 8 }} onClick={() => {
          setShowDataTable(true);
          setSelected_MapData_DataTable(selectedMapData)
        }}>
          <PiTable />
        </Button>
        {/* End Toggle Data Table */}

        <div style={{ flex: 1 }} />

        {/* Action khác */}
        <Button type='text' style={{ padding: 8 }}>
          <IoEllipsisHorizontal />
        </Button>
        {/* End Action khác */}
      </UI_Controllers>
      <UI_Divider />
      <UI_Tabs_Wrapper>
        <Tabs defaultActiveKey="1" items={[
          { key: '1', label: 'Style', children: <StyleTab /> },
          { key: '2', label: 'Lọc' },
        ]}
          onChange={() => { }}
          style={{ width: '100%', height: '100%' }}
        />
      </UI_Tabs_Wrapper>
      </UI_Body_Wrapper>
    </UI_Wrapper>
  </Rnd>
);
};

export default memo(StylingMapDataPanel);

const UI_LayerNameInput = styled(Input)`
  border: 0;
  padding: 10px 8px;
  font-size: 16px;
  font-weight: bold;
  &:focus {
    border: 1px solid #000;
  }
`;

const UI_Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  backdrop-filter: blur(10px);
  box-shadow: var(--shadows-paneShadow);
  border: 1px solid rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

const UI_Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const UI_Body_Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: calc(100% - 50px);
  position: relative;
  width: 100%;
`

const UI_Controllers = styled.div`
  margin-bottom: 8px;
  display: flex;
  flex-direction: row;
`

const UI_Tabs_Wrapper = styled.div`
  width: calc(100% - 16px);
  margin-left: 8px;
  height: 100%;
  overflow-y: auto;
`

const UI_Divider = styled.div`
  height: 1px;
  background-color: #f0f0f0;
  width: calc(100% - 16px);
  margin-left: 8px;
`